import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import "../../assets/css/recommendation-modal.css";
import {
  fetchLeakedCredentials,
  fetchLeakedCredentialsTotal,
  fetchLeakedCredentialsAction,
  fetchLeakedCredentialsGraph,
} from "../../actions/leakedCredentials";
import moment from "moment";
import BasicLineColumn from "../common/apexChart/lineChart";
import Pagination from "../Pagination/Pagination";
import $ from "jquery";
import TrialComponent from "../common/trialComponent";
import NoData from "../common/noDataComponetnt";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { rescanSingle } from "../../actions/users";
import PieChart from "../../components/common/dashboard12/piechart.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";

// Update the CSS styles for the date picker
const datePickerStyles = `
  
`;

const StolenCredentials = () => {
  // const id = JSON.parse(localStorage.getItem("user")).organisationId;
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [toggleArray, setToggleArray] = useState({});
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [filterValue, setFilterValue] = useState("all");
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [domainvalue, setDomains] = useState("");
  const [domainSelected, setDomainSelected] = useState("filterEmlDomain");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [limit, setLimit] = useState(10);
  const [pwdLength, setPwdLength] = useState('');
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const state = useSelector(
    (state) => state?.leakedCredential?.response?.data?.data
  );

  const domainValue = useSelector(
    (state) => state?.leakedCredential?.response?.data?.domains
  );

  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.de?.e;
  });

  const total = useSelector(
    (state) => state?.leakedCredential?.response?.data?.totalLeakedCredentials
  );
  const scanCompleted = useSelector(
    (state) => state?.leakedCredential?.scanCompleted
  );

  const auth = useSelector((state) => state?.auth?.user);
  let oldDnsDetails = useSelector(
    (state) => state.leakedCredential?.stolenGraph?.data
  );

  let totalCount = useSelector(
    (state) => state.leakedCredential?.stolenTotal?.data
  );

  let totalIp = 0,
    plainPasswords = 0;
  if (oldDnsDetails?.scanDetails) {
    // ipArray.push(oldDnsDetails?.scanDetails || 0);
    totalIp = oldDnsDetails?.ipLength || 0;
    plainPasswords = oldDnsDetails?.plainPassword || 0;
  }

  // Add these state variables to handle the date objects
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (orgId) {
      fetchLeakedCredentials(orgId, dispatch, page, category, filterValue, search, "filterEmailDomain", domainvalue, startDate, endDate, limit, pwdLength);
    } else {
      fetchLeakedCredentials(id, dispatch, page, category, filterValue, search, "filterEmailDomain", domainvalue, startDate, endDate, limit, pwdLength);
    }
  }, [id, dispatch, page, category, filterValue, search, "filterEmailDomain", domainvalue, startDate, endDate, limit, pwdLength]);

  useEffect(() => {
    setTotalItems(total);
  }, [total]);

  useEffect(() => {
    fetchLeakedCredentialsGraph(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchLeakedCredentialsTotal(id, dispatch);
  }, [id, dispatch]);

  let response = state;

  const plainPasswordPercent = ((plainPasswords || 0) / (totalIp || 0)) * 100;

  let mapData = response;

  // filterValue

  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
    clearPassword();
  };

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };


  const snooze = (_id, event) => {
    if (event == "") {
    }

    if (event == "riskAccepted") {
    }

    if (event == "markAsFalsePositive") {
    }

    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green",
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                leakedCredentialsIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              fetchLeakedCredentialsAction(
                id,
                dispatch,
                page,
                category,
                filterValue,
                search,
                data
              );
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
            // User canceled, do nothing
          },
        },
      });
    }
  };

  const submit = () => {
    const data = {
      action: action,
      leakedCredentialsIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchLeakedCredentialsAction(
      id,
      dispatch,
      page,
      category,
      filterValue,
      search,
      data
    );
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      leakedCredentialsIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchLeakedCredentialsAction(
      id,
      dispatch,
      page,
      category,
      filterValue,
      search,
      data
    );
    setSelectedIds([]);
  };

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const passwordShow = () => {
    $("[id$='_password']").html("******");
    $("[id$='_password_icon']").attr("class", "fa fa-eye");
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/dehashed/search/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}StolenCredentials.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const toggleIcon = (_id, value) => {
    let val = { ...toggleArray }; // Copy state
    const passwordElem = $("#" + _id + "_password");
    const iconElem = $("#" + _id + "_password_icon");

    if (val[_id]) {
      passwordElem.html("******");
      iconElem.attr("class", "fa fa-eye");
      delete val[_id];
    } else {
      passwordElem.html(value);
      iconElem.attr("class", "fa fa-eye-slash");
      val[_id] = true;
    }

    setToggleArray(val); // Update state
  };

  const clearPassword = () => {
    $("[id$='_password']").html("******");
    $("[id$='_password_icon']").attr("class", "fa fa-eye");
  }

  const reScan = () => {
    let data = {
      "moduleName": ["stolenCredentials"]
    }
    rescanSingle(id, data)
  }

  // Add these additional styles
  const tableStyles = {
    sourceCell: {
      maxWidth: "200px",
      position: "relative",
    },
    sourceCellContent: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    sourceCellExpanded: {
      whiteSpace: "normal",
      wordBreak: "break-word",
    },
    showMoreButton: {
      background: "none",
      border: "none",
      color: "#4a90e2",
      padding: "2px 5px",
      cursor: "pointer",
      fontSize: "12px",
      marginLeft: "5px",
      "&:hover": {
        textDecoration: "underline",
      }
    }
  };

  // Add this new state for expanded cells
  const [expandedCells, setExpandedCells] = useState({});

  // Add this toggle function
  const toggleSourceExpand = (id) => {
    setExpandedCells(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };


  const series = [
    totalCount?.totalComboLeakedCredentials || 0,
    totalCount?.totalThirdPartyLeakedCredentials || 0,
  ];

  const labels = ["Total Combo Credentials", "Total Third Party Credentials", "Total Leaked Credentials"];

  // Add these new state variables
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
    clearPassword();
  };

  // Update the cancelDateSelection function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  return (
    <div className="container-fluid">
      <style>{datePickerStyles}</style>
      <AccessPage></AccessPage>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Stolen Credentials</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Stolen Credentials
                </li>
              </ol>
              <br />
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
            <span className="mr-2">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setIsRecommendationModal(true);
                  }}
                  href="#"
                  className="btn btn-sm btn-primary mr-1"
                  style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                >
                  <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                  Recommendation
                </a>
              </span>
            <span>
              {auth?.accessLevel == "Admin" && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    reScan();
                  }}
                  style={{ color: "black", fontWeight: "bold" }}
                  className="btn btn-primary mr-1"
                >
                  Rescan
                </a>
              )}
            </span>
            <span>
              {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </span>
          </div>
        </div>
      </div>

      {typeof scanCompleted !== "undefined" && !scanCompleted && (
        <div className="card border-success">
          <ScanMessage />
        </div>
      )}

      <div className="row clearfix">
        <div className="col-lg-4 col-md-12">
          <div className="card RecordFoundCard">
            <div className="body" style={{ minHeight: "460px" }}>
              <h6 className="mb-4">Records Found</h6>
              <div className="d-flex mb-4 justify-content-center">
                {series && series?.length > 0 && <PieChart series={series} label={labels} />}
              </div>



              <div className="form-group">
                <label className="d-block" style={{ cursor: "pointer" }}>
                  <span className="greenShadow"></span>
                  Total Combo Credentials
                  <span className="float-right">
                    {totalCount?.totalComboLeakedCredentials}
                  </span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block" style={{ cursor: "pointer" }}>
                  <span className="yellowShadow"></span>
                  Total Third Party credentials
                  <span className="float-right">
                    {totalCount?.totalThirdPartyLeakedCredentials}
                  </span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block" style={{ cursor: "pointer" }}>
                  <span className="redShadow"></span>
                  Total Leaked Credentials
                  <span className="float-right">
                    {totalCount?.totalLeakedCredentials}
                  </span>
                </label>
              </div>


              {client?.subscriptionType === "trial" && (
                <div className="card border-warning">
                  <TrialComponent />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12">
          <div className="card">
            <div className="body" style={{ minHeight: "460px" }}>
              <h6 className="welcome-textSmall">Previous scan details</h6>
              {oldDnsDetails && (
                <BasicLineColumn
                  dates={oldDnsDetails?.dates}
                  ipArray={oldDnsDetails?.scanDetails}
                  color={["#08283f"]}
                  yAxis="Records Found"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("all");
              setPage(1);
              setFilterValue("all");
              setSearch("");
              setSelectedIds([]);
              passwordShow();
            }}
          >
            Current
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("risk-accepted");
              setPage(1);
              setFilterValue("all");
              setSearch("");
              setSelectedIds([]);
              passwordShow();
            }}
          >
            Risk Accepted
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("false-positive");
              setPage(1);
              setFilterValue("all");
              setSearch("");
              setSelectedIds([]);
              passwordShow();
            }}
          >
            False Positive
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("remidiated");
              setPage(1);
              setFilterValue("all");
              setSearch("");
              setSelectedIds([]);
              passwordShow();
            }}
          >
            Remediated
          </a>
        </li>
      </ul>
      <div className="card card_tableBox">
        <div className="body">
          <div className="row">
            <div className="col-sm-4 mb-2">
              <select
                className="custom-select custom-select-sm form-control form-control-sm"
                value={filterValue}
                onChange={(e) => { setFilterValue(e.target.value); setPage(1); clearPassword(); }}
              >
                <option value="all">Password Type</option>
                <option value="thirdParty">Third Party Credentials</option>
                <option value="combo">Combo Credentials</option>
              </select>
            </div>
            <div className="col-sm-4 mb-2">
              <div className="searchBoxInput p-0">
                <input
                  class="form-control form-control-sm ml-0 my-1"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  value={search}
                  onChange={handleSearchChange}
                />
              </div>
            </div>

            {domainSelected == 'filterOnlyRecordswithEmlSrcDomain' || domainSelected == 'filterEmlDomain'
              || domainSelected == 'filterSrcDomain'
              ?
              <>
                <div className="col-sm-4 mb-2">
                  <select
                    className="custom-select custom-select-sm form-control form-control-sm"
                    onChange={(e) => { setDomains(e.target.value); clearPassword(); }}
                  >
                    <option value="">
                      Please Select Domain
                    </option>
                    {domainValue?.map((r) => (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
              </> : null
            }
            <div className="col-sm-4 mb-2">
              <div className="date-picker-container">
                <div className="date-range-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Select date range"
                    value={formatDateRange()}
                    onClick={() => setDatePickerOpen(true)}
                    readOnly
                  />
                  <span className="calendar-icon">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-4 mb-2">
              <input
                type="number"
                className="form-control form-control-sm"
                placeholder="Password Length (≤)"
                value={pwdLength}
                onChange={(e) => {
                  const value = e.target.value;
                  setPwdLength(value);
                  setPage(1);
                  clearPassword();
                }}
                min="1"
                style={{ width: "100%" }}
              />
            </div>
            <div className="col-sm-4 mb-2">
              {selectedIds.length > 1 && userPermission && category === "all" && (
                <Box sx={{ width: 160 }}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedValue}
                      onChange={(event) => {
                        setAction(event.target.value);
                        snooze("", event.target.value);
                        clearPassword();
                        setPage(1);
                      }}
                    >
                      <MenuItem value="pleaseSelect">
                        Snooze Options
                      </MenuItem>
                      <MenuItem
                        value="riskAccepted"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        Risk Accepted
                      </MenuItem>
                      <MenuItem
                        value="markAsFalsePositive"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        False Positive
                      </MenuItem>
                      <MenuItem value="markAsRemidiated">
                        Remediated
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}
              {selectedIds.length > 1 && userPermission &&
                (category == "false-positive" ||
                  category == "risk-accepted") && (
                  <button
                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                    onClick={() => {
                      Unsnoozed(""); clearPassword();
                      setPage(1);
                    }}
                  >
                    Unsnooze
                  </button>
                )}
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-custom spacing5 mb-0">
              <thead>
                {client?.subscriptionType == "trial" ? (
                  <tr>
                    <th>Breached Count</th>
                    <th>Breached Database</th>
                    <th>Email Address</th>
                    <th>Password</th>
                    <th>Last Breach</th>
                    {category !== "all" && <th>Action Note</th>}
                    {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                      category === "risk-accepted" ||
                      category === "false-positive") && (
                        <th>Action</th>
                      )}
                  </tr>
                ) : (
                  <tr>
                    {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                      category === "risk-accepted" ||
                      category === "false-positive") && (
                        <th>
                          <input
                            type="checkbox"
                            checked={
                              selectedIds == 0 ? false : multiCheckTrue
                            }
                            onClick={() => {
                              multicheck(currentTableData);
                            }}
                            className="checkUncheck"
                          />
                        </th>
                      )}
                    <th>Password Type</th>
                    <th>Email Address</th>
                    <th>Password</th>
                    {/* <th>Breached Database</th> */}
                    <th>Source</th>
                    <th>Description</th>
                    {category !== "all" && <th>Action Note</th>}
                    <th style={{ width: "100px" }}>Created At</th>
                    {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                      category === "risk-accepted" ||
                      category === "false-positive") && (
                        <th>Action</th>
                      )}
                  </tr>
                )}
              </thead>
              <tbody>
                {client?.subscriptionType == "trial" ? (
                  <tr>
                    <td colSpan={5}>
                      {/* <NoData /> */}
                      <NoData />
                    </td>
                  </tr>
                ) : (
                  currentTableData?.map((row, index) => {
                    let password = row?.pwd?.split("") || ["N", "A"];
                    let date = row?.imp
                      ? row?.imp?.toString().substr(0, 4) +
                      "-" +
                      row?.imp?.toString().substr(4, 2) +
                      "-" +
                      row?.imp?.toString().substr(6, 2)
                      : "NA";
                    return (
                      <tr key={index}>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <input
                                onClick={() => singleClick(row?._id)}
                                checked={selectedIds?.includes(row?._id)}
                                type="checkbox"
                                className="checkUncheck"
                              />
                            </td>
                          )}
                        <td>
                          {row?.type} List
                        </td>
                        <td
                        >
                          {row?.eml || "NA"}
                          {/* <span className="badge badge-danger ml-0 mr-0">{row?.sources?.length || 1}</span> */}
                        </td>
                        <td>
                          <span
                            style={{
                              whiteSpace: "pre-wrap",
                              overflowWrap: "break-word",
                              display: "flex",
                            }}
                          >
                            <span id={`${row._id}_password`}>******</span>
                            <i
                              class="fa fa-eye"
                              style={{
                                marginLeft: "10px",
                                cursor: "pointer",
                                fontSize: "16px",
                                color: "#453AD1"
                              }}
                              id={`${row._id}_password_icon`}
                              onClick={() =>
                                toggleIcon(row._id, password)
                              }
                            ></i>
                          </span>
                        </td>
                        <td style={{ ...tableStyles.sourceCell }}>
                          <div style={{
                            ...tableStyles.sourceCellContent,
                            ...(expandedCells[row._id] ? tableStyles.sourceCellExpanded : {})
                          }}>
                            {row?.src || "NA"}
                          </div>
                          {row?.src && row.src.length > 30 && (
                            <Link to="#"
                              onClick={() => toggleSourceExpand(row._id)}
                              style={tableStyles.showMoreButton}
                            >
                              {expandedCells[row._id] ? "View Less" : "View More"}
                            </Link>
                          )}
                        </td>
                        <td style={{ ...tableStyles.sourceCell }}>
                          <div style={{
                            ...tableStyles.sourceCellContent,
                            ...(expandedCells[row._id + '_desc'] ? tableStyles.sourceCellExpanded : {})
                          }}>
                            {row?.type === "combo"
                              ? "Combo lists aggregate breached credentials, vary in format, and contain hashed or cleartext data."
                              : row?.desc || "NA"}
                          </div>
                          {((row?.type === "combo") || (row?.atr && row.atr.length > 30)) && (
                            <Link to="#"
                              onClick={() => toggleSourceExpand(row._id + '_desc')}
                              style={tableStyles.showMoreButton}
                            >
                              {expandedCells[row._id + '_desc'] ? "View Less" : "View More"}
                            </Link>
                          )}
                        </td>
                        {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                        <td>
                          {row?.createdAt ? moment(row?.createdAt).format(
                            "DD-MM-YYYY"
                          )
                            : "NA"}
                        </td>
                        {auth?.accessLevel != "Threat Analyst" && category === "all" && userPermission && (
                          <td>
                            <Box sx={{ width: 160 }}>
                              <FormControl fullWidth>
                                {/* <InputLabel
                                          sx={{ color: "#fff" }}
                                          id="demo-simple-select-label"
                                        >
                                          Action
                                        </InputLabel> */}
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={selectedValue}
                                  onChange={(event) => {
                                    setAction(event.target.value);
                                    snooze(row?._id, event.target.value);
                                  }}
                                >
                                  <MenuItem value="pleaseSelect">
                                    Snooze Options
                                  </MenuItem>
                                  <MenuItem
                                    value="riskAccepted"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId([row._id]);
                                    }}
                                  >
                                    Risk Accepted
                                  </MenuItem>
                                  <MenuItem
                                    value="markAsFalsePositive"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId([row._id]);
                                    }}
                                  >
                                    False Positive
                                  </MenuItem>
                                  <MenuItem value="markAsRemidiated">
                                    Remediated
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          </td>
                        )}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <button
                                className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                onClick={() => Unsnoozed(row?._id)}
                              >
                                Unsnooze
                              </button>
                            </td>
                          )}
                        {/* <td>
                          <span className="badge badge-danger ml-0 mr-0">{row?.sources?.length || 1}</span>
                        </td>
                        <td>{row.sources?.map(database_name=><span>{database_name}<br/></span>)}</td>
                        <td>{row?.line?.split(":")[0] || "NA"}</td>
                        <td>{row?.line?.split(":")[1] || "NA"}</td>
                        <td>{row?.last_breach || "NA"}</td> */}
                        {/* <td>{row.username.map(username=><span>{username}<br/></span>)}</td>
                        <td>{row.phone.map(phone=><span>{phone}<br/></span>)}</td>
                        <td>{row.ip_address.map(ip_address=><span>{ip_address}<br/></span>)}</td>
                        <td>{row?.address || "NA"}</td> */}
                      </tr>
                    );
                  })
                )}
                {/* <tr>
                    <td>
                      <span className="badge badge-danger ml-0 mr-0">1</span>
                    </td>
                    <td>LinkedIn Breach</td>

                    <td>aditya@ohphish.com</td>

                    <td>Password@1234</td>
                    <td>technobhardwaj33</td>
                    <td>9599292473</td>
                    <td>127.0.0.1</td>
                    <td>India</td>
                  </tr> */}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-content-center">
            <div className="dataTables_paginate">
              {totalItems > 0 && (
                <Pagination
                  className="pagination-bar"
                  currentPage={page}
                  totalCount={totalItems}
                  pageSize={limit}
                  onPageChange={(page) => {
                    setPage(page);
                    passwordShow()
                  }}
                />
              )}
            </div>
            {totalItems > 10 && (
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(e.target.value);
                  passwordShow();
                }}
                className="form-control limitSelectBox"
              >
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
              </select>
            )}
          </div>
        </div>
      </div>

      {/* Move date picker outside of the component tree to ensure proper rendering */}
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModal("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModal("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek has identified that credentials associated with the organization have been exposed
                  on dark web and underground sources. These credentials are considered compromised and may
                  already be in circulation among threat actors.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Are Stolen Credentials</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Stolen credentials typically originate from prior data breaches, phishing attacks,
                      malware infections, or third-party leaks. These credentials are aggregated into
                      "combo lists" and shared or sold across underground forums and marketplaces.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Why This Exposure Matters</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Credentials can be used for credential stuffing and account takeover attacks</li>
                      <li>Password reuse increases the blast radius across multiple systems</li>
                      <li>Successful compromise may lead to fraud, data leakage, or business disruption</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>How Threat Actors Commonly Exploit These Credentials</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Automated login attempts against email, VPN, SaaS, and portals</li>
                      <li>Access to cloud consoles, admin panels, or payment systems</li>
                      <li>Privilege escalation through reused or weak credentials</li>
                      <li>Persistence via mailbox rules or third-party app access</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Recommended Response Strategy</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Stolen credentials should be treated as permanently unsafe. The response should focus
                      on immediate credential reset, authentication hardening, access review, and continued
                      monitoring to ensure credentials are not misused.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Governance, Risk & Compliance</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Credential exposure events should be documented as security risks or incidents, as
                      applicable. Maintaining evidence of detection, remediation, and monitoring supports
                      ISO 27001 requirements, RBI Cyber Security Framework expectations, and CERT-In advisory
                      compliance.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Credential Reset & Containment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Force password reset for affected users</li>
                      <li>Ensure passwords are unique and not reused</li>
                      <li>Invalidate active sessions where supported</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.17 · RBI CSF</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Authentication Hardening</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Enable MFA for impacted users</li>
                      <li>Enforce MFA for privileged and executive accounts</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.17 · RBI IAM Controls</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Access & Activity Validation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Review authentication and login logs</li>
                      <li>Identify anomalous IPs or geolocations</li>
                      <li>Investigate any suspicious access attempts</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.15 · CERT-In</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Continuous Monitoring & Governance</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Maintain continuous dark web monitoring</li>
                      <li>Track reappearance or reuse of credentials</li>
                      <li>Document remediation and residual risk</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.24 · RBI Governance</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default StolenCredentials;
